import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    IconButton,
    useMediaQuery,
    Container,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";
import logo from '../../assets/logo.png'
import { IoCallOutline } from "react-icons/io5";
import { IoMailOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { useMediaQueries } from "../../usecontext/UseProvider";
import { LiaFacebookSquare } from "react-icons/lia";
import { getOurCategories } from "../../services/OurCategories";
import { SlLocationPin } from "react-icons/sl";

const Footer = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { contactUSData, wpNumber } = useMediaQueries()
    const [ourCategoriesData, setOurCategoriesData] = useState([])
    const navigate = useNavigate();

    const getOurCategoriesData = async () => {
        try {
            const response = await getOurCategories();
            setOurCategoriesData(response?.categoryData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getOurCategoriesData();
    }, []);

    return (
        <Box
            sx={{
                backgroundColor: "#1D1D1D",
                color: "#fff",
                pt: 5,
            }}
        >
            <Container >
                <Grid
                    container
                    spacing={4}
                    justifyContent={isMobile ? "center" : "space-between"}
                    alignItems="flex-start"
                >
                    {/* Brand Section */}
                    <Grid item xs={12} sm={6} md={4} >
                        <Box>
                            <img src={logo} alt="logo" style={{ height: "50px" }} />
                        </Box>
                        <Typography variant="body2" sx={{ mt: 2, color: '#fff', fontSize: { sm: '18px' } }}>
                            Discover the ultimate collection of timeless furniture at Balam Zula.
                            Transform your space with exceptional craftsmanship and elegant
                            designs. Browse our range today and bring a touch of sophistication to
                            your home.
                        </Typography>
                        <Box display="flex" gap={2} mt={3}>
                            <IconButton color="inherit"
                                sx={{
                                    border: '1px solid white',
                                    '&:hover': {
                                        backgroundColor: '#01A0E2',
                                        borderColor: '#01A0E2',
                                        cursor: 'pointer'
                                    }
                                }}
                                onClick={() => window.open(`${contactUSData?.instagramLink}`)}
                            >
                                <FaInstagram />
                            </IconButton>
                            <IconButton color="inherit"
                                sx={{
                                    border: '1px solid white',
                                    '&:hover': {
                                        backgroundColor: '#01A0E2',
                                        borderColor: '#01A0E2',
                                        cursor: 'pointer'
                                    }
                                }}
                                onClick={() => window.open(`https://wa.me/${wpNumber}`, '_blank')}>
                                <FaWhatsapp />
                            </IconButton>
                            <IconButton color="inherit"
                                sx={{
                                    border: '1px solid white',
                                    '&:hover': {
                                        backgroundColor: '#01A0E2',
                                        borderColor: '#01A0E2',
                                        cursor: 'pointer'
                                    }
                                }}
                                onClick={() => window.open(`${contactUSData?.facebookLink}`)}
                            >
                                <LiaFacebookSquare />
                            </IconButton>
                        </Box>
                    </Grid>

                    {/* Quick Links Section */}
                    <Grid item xs={12} sm={6} md={2} sx={{ mt: { md: 3 } }}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#fff' }}>
                            Quick Links
                        </Typography>
                        <Box display="flex" flexDirection="column" gap={1.3}>
                            <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>
                                Home
                            </Link>
                            <Link to="/aboutus" style={{ color: 'white', textDecoration: 'none' }}>
                                About us
                            </Link>
                            <Link to="/product" style={{ color: 'white', textDecoration: 'none' }}>
                                Products
                            </Link>
                            <Link to="/contactus" style={{ color: 'white', textDecoration: 'none' }}>
                                Contact us
                            </Link>
                        </Box>
                    </Grid>

                    {/* Categories Section */}
                    <Grid item xs={12} sm={6} md={3} sx={{ mt: { md: 3 } }}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#fff' }}>
                            Categories
                        </Typography>
                        <Box display="flex" flexDirection="column" gap={1.3}>
                            {ourCategoriesData?.map((category, index) => (
                                <Link to={`/product/${category?._id}`} style={{ color: 'white', textDecoration: 'none' }} key={index}>
                                    {category?.name}
                                </Link>
                            ))}
                        </Box>
                    </Grid>

                    {/* Locations Section */}
                    <Grid item xs={12} sm={6} md={3} sx={{ mt: { md: 3 } }}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#fff' }}>
                            Locations
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: '16px', display: "flex", mb: 1.3, gap: 1, cursor: 'pointer', color: '#fff' }}>
                            <IoCallOutline style={{ color: '#01A0E2', fontSize: '18px' }}
                                onClick={() => window.open(`tel:${contactUSData?.mobileNumber}`)}
                            />
                            {contactUSData?.mobileNumber}
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: '16px', display: "flex", mb: 1.3, gap: 1, color: '#fff' }}>
                            <IoMailOutline style={{ color: '#01A0E2', fontSize: '18px' }} /> {contactUSData?.email}
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: '16px', display: "flex", gap: 1, color: '#fff' }}>
                            <SlLocationPin style={{ color: '#01A0E2', fontSize: '40px', width: 'fit-content', height: 'fit-content' }} /> {contactUSData?.address}
                        </Typography>
                    </Grid>
                </Grid>

                {/* Footer Bottom */}
            </Container>
            <Box
                sx={{
                    borderTop: "1px solid #333",
                    mt: 4,
                    py: 2,
                    textAlign: "center",
                }}
            >
                <Typography variant="body2" sx={{ color: '#fff' }}>
                    Copyright© 2024 Balam Zula. All rights reserved.
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;